export default __webpack_public_path__ + "static/media/Remington_Wood1@2x.337b68e3.jpg";